import { lazy, Suspense } from 'react';

import { ListSkeleton } from '@/shared/components/skeletons';
import { Skeleton } from '@/shared/ui/skeleton';

/*
 * FullCalendar and the event card load on demand; these wrappers are what the registry renders.
 */

const EventPanel = lazy(() => import('./components/panel/EventPanel'));
const GroupCalendarTab = lazy(async () => ({
  default: (await import('./components/tabs')).GroupCalendarTab,
}));
const ProfileCalendarTab = lazy(async () => ({
  default: (await import('./components/tabs')).ProfileCalendarTab,
}));

function PanelFallback() {
  return (
    <div className="space-y-4 p-6" aria-busy>
      <Skeleton className="h-6 w-2/3" />
      <Skeleton className="h-4 w-40" />
      <ListSkeleton rows={4} avatar={false} />
    </div>
  );
}

function TabFallback() {
  return (
    <div className="space-y-3" aria-busy>
      <Skeleton className="h-8 w-64" />
      <Skeleton className="h-[26rem] w-full rounded-xl" />
    </div>
  );
}

export function LazyEventPanel({ id }: { id: string }) {
  return (
    <Suspense fallback={<PanelFallback />}>
      <EventPanel id={id} />
    </Suspense>
  );
}

export function LazyGroupCalendarTab({ groupId }: { groupId: string }) {
  return (
    <Suspense fallback={<TabFallback />}>
      <GroupCalendarTab groupId={groupId} />
    </Suspense>
  );
}

export function LazyProfileCalendarTab({ userId }: { userId: string }) {
  return (
    <Suspense fallback={<TabFallback />}>
      <ProfileCalendarTab userId={userId} />
    </Suspense>
  );
}
